import { render, staticRenderFns } from "./redirectional.vue?vue&type=template&id=3a41a1cc"
import script from "./redirectional.vue?vue&type=script&lang=js"
export * from "./redirectional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports